module.exports = __webpack_public_path__ + "static/media/turkeycafe.9b97f331.jpg";